import { Box, Breadcrumbs, Link, Tab, Tabs, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { Link as RouterLink, Outlet, useLocation } from 'react-router-dom';
import PlannerFooter from '../../../Components/menu_planner/PlannerFooter';

const masterDataTabs = [
  {
    label: 'Tags',
    path: '/master-data/tags',
  },
  {
    label: 'Ingredients',
    path: '/master-data/ingredients',
  },
];

const MasterDataScreen = () => {
  const location = useLocation();

  const activeTab = useMemo(
    () =>
      masterDataTabs.find(({ path }) => location.pathname.startsWith(path))?.path ??
      masterDataTabs[0].path,
    [location.pathname]
  );

  return (
    <Box>
      <Box
        className='content-horizontal-margin'
        sx={{
          display: 'flex',
          flexDirection: 'column',
          rowGap: 3,
          mt: 3,
          mb: 3,
        }}
      >
        <Breadcrumbs aria-label='breadcrumb'>
          <Link
            component={RouterLink}
            underline='hover'
            color='inherit'
            to='/dashboard'
          >
            Home
          </Link>
          <Typography variant='s16_w500_orange'>Master Data</Typography>
        </Breadcrumbs>

        <Box sx={{ display: 'flex', flexDirection: 'column', rowGap: 0.5 }}>
          <Typography variant='s24_w600' color='primery' component='div'>
            Master Data
          </Typography>
          <Typography variant='s16_w500' color='#6B7280' component='div'>
            Manage the reference lists used across the Foodfe app.
          </Typography>
        </Box>

        <Box
          sx={{
            alignSelf: 'flex-start',
            p: 0.5,
            borderRadius: '16px',
            backgroundColor: '#EEF2FF',
          }}
        >
          <Tabs
            value={activeTab}
            aria-label='Master data sections'
            TabIndicatorProps={{ style: { display: 'none' } }}
            sx={{
              minHeight: 'unset',
              '& .MuiTabs-flexContainer': {
                gap: 1,
              },
            }}
          >
            {masterDataTabs.map(({ label, path }) => (
              <Tab
                key={path}
                value={path}
                label={label}
                component={RouterLink}
                to={path}
                disableRipple
                sx={{
                  minHeight: 'unset',
                  minWidth: 'unset',
                  px: 2.5,
                  py: 1.25,
                  borderRadius: '12px',
                  color: '#5B6B8C',
                  fontSize: '1.6rem',
                  fontWeight: 600,
                  lineHeight: '2rem',
                  textTransform: 'none',
                  '&.Mui-selected': {
                    color: '#342C47',
                    backgroundColor: '#FFFFFF',
                    boxShadow: '0px 4px 12px rgba(17, 24, 39, 0.08)',
                  },
                }}
              />
            ))}
          </Tabs>
        </Box>

        <Outlet />
      </Box>

      <PlannerFooter />
    </Box>
  );
};

export default MasterDataScreen;
